import { isIOS } from '@/utils/handleLinkClick';

// Extend the Window interface to include ActiveXObject
declare global {
    interface Window {
        ActiveXObject?: any;
    }
}

const downloadFile = async (url: string): Promise<void> => {
    if (window.ActiveXObject) {
        // Internet Explorer specific code
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.document.close();
            newWindow.document.execCommand('SaveAs', true, url);
            newWindow.close();
        }
    } else {
        // Show the overlay
        const overlay = document.getElementById('overlay');
        if (overlay) {
            overlay.style.display = 'block';
        }
        const data = await fetch(url);
        const blob = await data.blob();
        const downloadedBlob = new Blob([blob], {
            type: 'application/octet-stream',
        });
        const objectUrl = URL.createObjectURL(downloadedBlob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.target = '_blank';
        const filename = url.substring(url.lastIndexOf('/') + 1);
        anchor.download = filename;

        // Check if the device is iOS
        if (isIOS) {
            // For iOS devices, use a different approach
            document.location = anchor.href;
            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            anchor.dispatchEvent(clickEvent);
            (window.URL || window.webkitURL).revokeObjectURL(anchor.href);
        } else {
            // For other devices, use the standard approach
            document.body.appendChild(anchor);
            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            anchor.dispatchEvent(clickEvent);
            document.body.removeChild(anchor);
            (window.URL || window.webkitURL).revokeObjectURL(anchor.href);
        }
        // Hide the overlay
        if (overlay) {
            overlay.style.display = 'none';
        }
    }
};

export default downloadFile;
